import "./ButtonSubmit.scss";
export const ButtonSubmit = ({ text, onClick }) => {
  return (
    <>
      <button type="submit" onClick={onClick} className="button">
        {text}
        <span>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3933 8.49342C16.3299 8.32975 16.2347 8.18022 16.1133 8.05342L9.44667 1.38675C9.32235 1.26243 9.17476 1.16382 9.01233 1.09654C8.8499 1.02926 8.67581 0.994629 8.5 0.994629C8.14493 0.994629 7.80441 1.13568 7.55333 1.38675C7.42902 1.51107 7.3304 1.65866 7.26312 1.82109C7.19584 1.98351 7.16121 2.15761 7.16121 2.33342C7.16121 2.68849 7.30226 3.02901 7.55333 3.28008L11.9533 7.66675H1.83333C1.47971 7.66675 1.14057 7.80723 0.890525 8.05728C0.640476 8.30732 0.5 8.64646 0.5 9.00008C0.5 9.35371 0.640476 9.69284 0.890525 9.94289C1.14057 10.1929 1.47971 10.3334 1.83333 10.3334H11.9533L7.55333 14.7201C7.42836 14.844 7.32917 14.9915 7.26148 15.154C7.19379 15.3165 7.15894 15.4907 7.15894 15.6667C7.15894 15.8428 7.19379 16.017 7.26148 16.1795C7.32917 16.342 7.42836 16.4895 7.55333 16.6134C7.67728 16.7384 7.82475 16.8376 7.98723 16.9053C8.14971 16.973 8.32398 17.0078 8.5 17.0078C8.67602 17.0078 8.85029 16.973 9.01277 16.9053C9.17525 16.8376 9.32272 16.7384 9.44667 16.6134L16.1133 9.94675C16.2347 9.81995 16.3299 9.67042 16.3933 9.50675C16.5267 9.18214 16.5267 8.81803 16.3933 8.49342Z"
              fill="#191129"
            />
          </svg>
        </span>
      </button>
    </>
  );
};
